import { CwUtils } from 'cw-utils';

import { Location } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiGateway } from '../../../api-gateway';
import { Category } from '../../../models/backend-definitions.module';
import { PageOptions } from '../../../util/backend-util-module';

@Injectable()
export class CategoryListProvider implements Resolve<any> {
    category: Category[];
    categoryEdit: Category;
    onDataChanged: BehaviorSubject<any>;
    routeParams: any;
    state: any;
    pageOptions: PageOptions;
    currentPage: PageOptions;

    constructor(
        public gw: ApiGateway,
        private location: Location,
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        // Get state for current or new page
        this.state = this.location.getState();
        if (this.state?.currentPage && state.url.includes(this.state?.path)) {
            this.currentPage = this.state?.currentPage;
        }
        this.categoryEdit = this.state?.currentCategory;

        if (this.currentPage) {
            this.pageOptions = this.currentPage;
        }
        else {
            this.pageOptions = new PageOptions();
            this.pageOptions.fieldSort = 'name';
        }
        return new Promise<void>((resolve, reject) => {
            Promise.all([
                this.getPage(this.pageOptions)
            ]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    get(id: number): Observable<Category> {
        if (!id) {
            return null;
        }
        return this.gw.get('category/:id', { id: id });
    }

    get currentCategory(): Category {
        return this.categoryEdit;
    }

    getAll(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.get('category/').subscribe((res: HttpResponse<any>) => {
                this.category = res.body;
                this.onDataChanged.next(this.category);
                resolve(res);
            }, reject);
        });

    }

    getMainCategory(categoryId): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.get('category/mainCategory/' + categoryId).subscribe((res: HttpResponse<any>) => {
                this.category = res.body;
                this.onDataChanged.next(this.category);
                resolve(res);
            }, reject);
        });
    }

    getSubCategory(categoryId): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.get('category/subCategory/' + categoryId).subscribe((res: HttpResponse<any>) => {
                this.category = res.body;
                this.onDataChanged.next(this.category);
                resolve(res);
            }, reject);
        });
    }

    getPage(pageOptions: PageOptions): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('category/search', pageOptions).subscribe((res: HttpResponse<any>) => {
                if (!CwUtils.compare(this.category, res.body.content) && res.body.content.length > 0) {
                    this.category = res.body.content;
                    this.onDataChanged.next(this.category);
                } else {
                    this.category = res.body.content;
                }
                resolve(res);
            }, reject);
        });
    }

    getPageSimple(pageOptions: PageOptions): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('category/search/simple-list', pageOptions).subscribe((res: HttpResponse<any>) => {
                resolve(res);
            }, reject);
        });
    }


    getPageSettings() {
        if (this.currentPage) {
            return this.pageOptions;
        } else {
            return;
        }
    }
}

